import React from "react";
import { Collapse } from "antd";
import CollapseIcon from "../assets/icons/collapse-icon.svg";
import TicketPinkIcon from "../assets/icons/ticket-pink-icon.svg";

function Ticket({ ticket }: any) {
    const wallet = ticket?.wallet_address || "";
    const price = ticket?.price;
    const winning = ticket?.winning || "";

    return (
        <div className="ticket">
            <Collapse
                items={[
                    {
                        label: (
                            <div className="ticket-collapse-item">
                                <div className="ticket-collapse-item_left">
                                    <img src={TicketPinkIcon} alt="icon" width={32} height={32} />
                                    <span className="ticket-collapse-item_left__ticket-number">
                                        <span style={{ fontStyle: "italic" }}>N</span>
                                        {ticket?.ticket_number}
                                    </span>
                                </div>

                                {ticket?.is_active ? (
                                    <div className="ticket-collapse-item_right-active">
                                        Активный
                                    </div>
                                ) : (
                                    <div className="ticket-collapse-item_right-not-active">
                                        Неактивный
                                    </div>
                                )}
                            </div>
                        ),

                        children: (
                            <div className="ticket-collapse-item-content">
                                <div className="ticket-collapse-item-content_item">
                                    <div className="ticket-collapse-item-content_item__left">
                                        Адрес кошелька:
                                    </div>
                                    <div className="ticket-collapse-item-content_item__right">
                                        {wallet
                                            ? wallet.slice(0, 5) + "..." + wallet.slice(-5)
                                            : "-"}
                                    </div>
                                </div>

                                <div className="ticket-collapse-item-content_item">
                                    <div className="ticket-collapse-item-content_item__left">
                                        Цена:
                                    </div>
                                    <div className="ticket-collapse-item-content_item__right">
                                        {price ? `${price} GRAM` : "-"}
                                    </div>
                                </div>

                                <div className="ticket-collapse-item-content_item">
                                    <div className="ticket-collapse-item-content_item__left">
                                        Выигрыш:
                                    </div>

                                    {winning ? (
                                        <div className="ticket-collapse-item-content_item__right">
                                            {winning} GRAM
                                        </div>
                                    ) : (
                                        <div className="ticket-collapse-item-content_item__right">
                                            -
                                        </div>
                                    )}
                                </div>
                            </div>
                        ),
                    },
                ]}
                rootClassName="ticket-collapse"
                expandIconPosition="end"
                bordered={false}
                expandIcon={() => <img src={CollapseIcon} alt="icon" />}
            />
        </div>
    );
}

export default Ticket;